import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { setBackButtonHandler } from './components/store/backButton';
import { initialFetch } from './components/initialFetch';

import './UI/fonts/fonts.css'
import { GlobalStyle } from './UI/components/GlobalStyle';

import Loader from './UI/components/UIKit/Loader';
import Header from './modules/Header/Header';
import AppRouter from './components/AppRouter';
import Welcome from './UI/components/Welcome';
import QrResult from './UI/components/QrResult';

declare global {
  interface Window {
    Telegram: any;
  }
}
const AppWrapper =styled.div<{saveArea:any}>`
  position: absolute;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  overflow: auto;
  padding-top: calc(${p => p.saveArea || 0}px - 20px);
  transform: translateZ(0);
`

const isPortraitOrientation = () =>
  window.matchMedia?.('(orientation: portrait)').matches ?? window.innerHeight >= window.innerWidth;

const lockPortraitOrientation = () => {
  const webApp = window.Telegram?.WebApp;
  const canLockTelegramOrientation =
    typeof webApp?.lockOrientation === 'function' &&
    (typeof webApp.isVersionAtLeast !== 'function' || webApp.isVersionAtLeast('8.0'));
  const canLockScreenOrientation = typeof window.screen.orientation?.lock === 'function';

  if (!canLockTelegramOrientation && !canLockScreenOrientation) {
    return undefined;
  }

  let locked = false;

  const lockWhenPortrait = () => {
    if (locked || !isPortraitOrientation()) return;

    try {
      window.screen.orientation?.lock?.('portrait').catch(() => undefined);
    } catch {}

    if (canLockTelegramOrientation) {
      webApp.lockOrientation();
      locked = true;
    }
  };

  lockWhenPortrait();
  window.addEventListener('orientationchange', lockWhenPortrait);
  window.addEventListener('resize', lockWhenPortrait);

  return () => {
    window.removeEventListener('orientationchange', lockWhenPortrait);
    window.removeEventListener('resize', lockWhenPortrait);
  };
};

function App() {
  const [ params ] = useSearchParams();
  const closewelcomeModal = () => setWelcomeOpen(false);
  const navigate = useNavigate();
  const [ welcomeOpen,setWelcomeOpen ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(true);

  useEffect(() => {
      if(!window.Telegram) return;

      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      window.Telegram.WebApp.expand();
      if (isMobile) {
        window.Telegram.WebApp.requestFullscreen();
      }
      const cleanupOrientationLock = lockPortraitOrientation();
      window.Telegram.WebApp.disableVerticalSwipes();
      window.Telegram.WebApp.isClosingConfirmationEnabled = true;
      window.Telegram.WebApp.setHeaderColor('#6A2B91');
      setBackButtonHandler(() => navigate(-1));

      if(!window.Telegram.WebApp.initDataUnsafe.user) return cleanupOrientationLock;
      if(!window.Telegram.WebApp.initDataUnsafe.user.allows_write_to_pm){
        window.Telegram.WebApp.requestWriteAccess()
        window.Telegram.WebApp.onEvent('writeAccessRequested',(event:any) => fn(event))
      }

      initialFetch(setIsLoading,setWelcomeOpen,params,navigate)
      return cleanupOrientationLock;
  },[])

function fn(event:any) {
  if(event.status === 'cancelled'){
    setTimeout(()=>{
      window.Telegram.WebApp.requestWriteAccess()
    },4000)
  }
    /*if (event.status === 'sent') {
      console.log('Phone number received!');
    }*/
}
  /*useEffect(()=>{
    //@ts-ignore
    window.Telegram.WebView.onEvent('writeAccessRequested',(event,status) => fn(event))
    //window.TelegramWebviewProxy.postEvent('web_app_request_phone',null );//@ts-ignore
   // window.Telegram.WebView.onEvent('phone_requested', (event,status) => fn(status))
   // window.Telegram.WebView.receiveEvent('phone_requested',(event)=> console.log(event) )//('phone_requested',fn(event))
  },[])*/

  return (
    <>
      <AppWrapper saveArea={window.Telegram.WebApp.safeAreaInset.top + window.Telegram.WebApp.contentSafeAreaInset.top}>
        <GlobalStyle/>
        {isLoading ? 
          <Loader/>
        : 
          <>
            <Header/>
            <AppRouter/>
          </>
        }
      </AppWrapper>
      <QrResult/>
      <Welcome visible={welcomeOpen} close={closewelcomeModal}/>
    </>
  );
}

export default App;
